import React from 'react';
import { Box, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { ProviderPayablesList } from 'features/salesOrder/components/ProviderPayablesList';
import { ProviderPaymentsNav } from './ProviderPaymentsNav';

export const ProviderPaymentsListPage = (): JSX.Element => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Layout>
			<Grid container paddingY={isMobile ? 2 : 5} justifyContent="center">
				<Grid item xs={12} sx={{ ml: isMobile ? 2 : 20, mb: isMobile ? 2 : 0 }}>
					<Typography variant={isMobile ? 'h5' : 'h4'} sx={{ fontWeight: 500 }}>
						Pagos a Proveedores
					</Typography>
				</Grid>
				<Grid item xs={12} sx={{ px: isMobile ? 2 : 20 }}>
					<Box sx={{ mt: 2 }}>
						<ProviderPaymentsNav />
					</Box>
					<ProviderPayablesList />
				</Grid>
			</Grid>
		</Layout>
	);
};
